'use client'

import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { useProductInfo } from 'product/services/productInfo/client'
import { EmptyProductCard } from 'product-card/components/EmptyProductCard/EmptyProductCard'
import { ProductCard } from 'product-card/components/ProductCard'
import { ProductCardStoreProvider } from 'product-card/context/ProductCardStoreContext'
import { useProductDataContext } from 'product-card/hooks/useProductDataContext'
import type { ProductCardProps } from 'product-card/types'
import { useCallback, useState } from 'react'

export const ClientProductCard = ({
	productId,
	lookId,
	colorId,
	imageSortCriteria,
	priority,
	dataTestId,
	isTwoColumnSize,
	className,
	location,
	productListId,
	showDiscount,
	noDraggable,
	onAddToCart,
	onImageClick,
}: ProductCardProps) => {
	const {
		country: { countryISO, languageISO },
	} = useMasterData()
	const [cardIntersected, setCardIntersected] = useState(false)

	const { productData: productDataFromServer } = useProductDataContext()

	const { data: productDataFromClient } = useProductInfo({
		productId,
		country: countryISO,
		language: languageISO,
		enabled: !productDataFromServer && cardIntersected,
	})

	const productData = productDataFromServer ?? productDataFromClient

	const handleEmptyCardIntersect = useCallback(() => {
		setCardIntersected(true)
	}, [])

	if (!(productData && cardIntersected)) {
		return (
			<EmptyProductCard
				isTwoColumnSize={!!isTwoColumnSize}
				onIntersect={handleEmptyCardIntersect}
			/>
		)
	}

	return (
		<ProductCardStoreProvider
			product={productData}
			dataTestId={dataTestId}
			lookId={lookId}
			defaultColorId={colorId}
			location={location}
			featured={!!isTwoColumnSize}
			productListId={productListId}
			noDraggable={noDraggable}
			imageSortCriteria={imageSortCriteria}
			priority={priority}
			showDiscount={showDiscount}
			onAddToCart={onAddToCart}
			onImageClick={onImageClick}
		>
			<ProductCard className={className} />
		</ProductCardStoreProvider>
	)
}
